module.exports = __webpack_public_path__ + "static/media/x46-logo.6afd45fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X46/x46-logo.svg
// module id = 207
// module chunks = 0